module.exports = __webpack_public_path__ + "img/unstabilized_default.59996599.png";